// Shared portfolio-application status helpers. Stories 1.24 + 1.26.
//
// First extraction: Story 1.24 inlined `statusBadgeVariant` +
// `MyApplicationsStatusFilter` in `CreatorPortfoliosPage.tsx`. Story
// 1.26's dashboard surface became the second consumer, so the inline
// helpers are promoted here to keep them in lockstep. Future stories
// adding portfolio-application UIs should import from this module.

export type PortfolioApplicationStatus =
  | "pending"
  | "approved"
  | "rejected"
  | "withdrawn";

export type MyApplicationsStatusFilter =
  | "any"
  | PortfolioApplicationStatus;

export const PORTFOLIO_APPLICATION_STATUS_FILTERS: readonly MyApplicationsStatusFilter[] = [
  "any",
  "pending",
  "approved",
  "rejected",
  "withdrawn",
] as const;

/**
 * Map an application status to a `@greenhold/components` Badge variant.
 * Kept here (not in the component package) because the variant choices
 * are app-level UX decisions, not part of the component library's
 * shape.
 */
export function statusBadgeVariant(
  status: PortfolioApplicationStatus,
): "warning" | "success" | "destructive" | "secondary" {
  switch (status) {
    case "pending":
      return "warning";
    case "approved":
      return "success";
    case "rejected":
      return "destructive";
    case "withdrawn":
      return "secondary";
  }
}
